<!--
 * @Author: wanghui@ykccn.com
 * @Date: 2023-02-13
 * @Description: 营销管理/平台营销工具/平台卡券活动/领取记录
-->
<template>
  <div>
    <scroll-layout>
      <template #header>
        <div v-if="pageButtons.length > 0" class="button-wrap">
          <ykc-button
            v-for="(button, index) in pageButtons"
            :key="button.id || index"
            v-bind="button"
            @click="button.handleClick(button, $event)">
            {{ button.text }}
          </ykc-button>
        </div>
        <ykc-search ref="YkcSearch" :data="searchItems" @click="handleSearchConfirm" />
      </template>
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        :operateButtons="tableOperateButtons">
        <template #title>
          <div>
            <span class="ykc-table-header-title">{{ tableTitle }}</span>
            <span class="ykc-table-header-subtitle">导入数量：{{ count }}</span>
          </div>
        </template>
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button type="plain" @click="exportBlob">导出</ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="total"
          :current-page.sync="currentPage"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageSize"
          @size-change="handlePaginationSizeChange" />
      </ykc-table>
    </scroll-layout>
    <!--申请退款弹窗 -->
    <ykc-operation-dialog
      :title="refundTitle"
      show-footer
      :show.sync="showRefund"
      :before-close="onCLose"
      :before-cancel="onCLose"
      :before-confirm="onRefund">
      <div slot="content">
        <ykc-form ref="refundForm" :model="refundForm" :rules="refundRules">
          <ykc-form-item label="退款订单">
            <span>{{ refundInfo.saleOrderNo }}</span>
          </ykc-form-item>
          <ykc-form-item label="退款用户">
            <span>{{ refundInfo.userAccount }}</span>
          </ykc-form-item>
          <ykc-form-item label="退款金额">
            <span>{{ refundInfo.refundableAmount }}</span>
          </ykc-form-item>
          <ykc-form-item label="退款原因" prop="reason">
            <ykc-input
              v-model="refundForm.reason"
              type="textarea"
              maxlength="200"
              :autosize="{ minRows: 2 }"
              placeholder="请输入退款原因"></ykc-input>
          </ykc-form-item>
        </ykc-form>
      </div>
    </ykc-operation-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import dayjs from 'dayjs';
  import { businessPlatform, couponActivity, orderPage } from '@/service/apis';
  import { offlineExport } from '@/utils'; // 新增/编辑组件
  import { dictDesc } from '@/store/dict';
  import regexpObj from '@/utils/regexp';

  export default {
    name: 'platformCouponActivity',
    components: {},
    computed: {
      ...mapGetters([]),
    },
    data() {
      return {
        count: 0,
        tableOperateButtons: [],
        activityId: '',
        activityType: '',
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        /**
         * 查询数据
         */
        searchItems: [],
        tableData: [],

        tableColumns: [
          { label: '领取用户', prop: 'userAccount' },
          { label: '归属客户', prop: 'userOrgName' },
          { label: '用户分组', prop: 'userGroupName' },
          { label: '活动名称', prop: 'activityName' },
          {
            label: '活动类型',
            prop: 'activityType',
            scopedSlots: {
              default: ({ row }) => {
                return dictDesc('activityTypes', row.activityType);
              },
            },
          },
          { label: '承担方', prop: 'activityInitiatorText' },
          { label: '参与时间', width: '250px', prop: 'receiveTime' },
        ],
        tableTitle: '领取记录清单',
        total: 0,
        currentPage: 1,
        pageSize: 10,
        showRefund: false,
        refundTitle: '申请退款',
        saleOrderNo: '',
        refundInfo: {
          saleOrderNo: '',
          userAccount: '',
          refundableAmount: '',
        },
        refundForm: {
          reason: '',
        },
        refundRules: {
          reason: [{ required: true, message: '请输入退款原因', trigger: 'blur' }],
        },
      };
    },
    created() {
      this.activityId = this.$route.query.activityId || '';
      this.activityType = this.$route.query.activityType || '';
      if (this.activityType === '7') {
        // 拉新活动查询条件及列表配置项有所改动
        this.searchItems = [];
        this.tableColumns.splice(2, 1); // 删除用户分组
        this.tableColumns[0] = { label: '受邀请人', prop: 'userAccount' };
        this.tableColumns[1] = { label: '邀请人', prop: 'userOrgName' };
      } else if (this.activityType === '2') {
        this.tableColumns = [
          ...this.tableColumns,
          { label: '充值金额', prop: 'payAmount' },
          { label: '最近一次充电站点', prop: 'lastStationName' },
          { label: '省份', prop: 'provinceName' },
          { label: '城市', prop: 'cityName' },
          { label: '最近一次充电开始时间', width: '250px', prop: 'lastChargeTime' },
        ];
        this.searchItems = [
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'collectioTime',
            label: '领取时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '领取用户',
            placeholder: '请输入领取用户',
          },
          {
            comName: 'YkcInput',
            key: 'userOrgName',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
        ];
      } else if (this.activityType === '4' || this.activityType === '9') {
        this.tableColumns = [
          ...this.tableColumns,
          { label: '最近一次充电站点', prop: 'lastStationName' },
          { label: '省份', prop: 'provinceName' },
          { label: '城市', prop: 'cityName' },
          { label: '最近一次充电开始时间', width: '250px', prop: 'lastChargeTime' },
        ];
        this.searchItems = [
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'collectioTime',
            label: '领取时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '领取用户',
            placeholder: '请输入领取用户',
          },
          {
            comName: 'YkcInput',
            key: 'userOrgName',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
        ];
      } else if (this.activityType === '8') {
        this.tableColumns = [
          { label: '销售单号', prop: 'saleOrderNo' },
          ...this.tableColumns,
          { label: '可退金额', prop: 'refundableAmount' },
          { label: '用户支付价格', prop: 'payAmount' },
          { label: '是否开票', prop: 'isInvoice' },
          { label: '最近一次充电站点', prop: 'lastStationName' },
          { label: '省份', prop: 'provinceName' },
          { label: '城市', prop: 'cityName' },
          { label: '最近一次充电开始时间', prop: 'lastChargeTime' },
        ];
        this.tableOperateButtons = [
          {
            render: (h, data, { row }) =>
              row.refundStatus === 0 && row.refundableAmount > 0 ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.handleRefund(row);
                  }}>
                  {this.isOver350Days(row.receiveTime) ? '超时退款' : '退款'}
                </ykc-button>
              ) : null,
          },
        ];
        this.searchItems = [
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'collectioTime',
            label: '领取时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '领取用户',
            placeholder: '请输入领取用户',
          },
          {
            comName: 'YkcInput',
            key: 'userOrgName',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
        ];
      } else {
        this.searchItems = [
          {
            comName: 'YkcDatePicker',
            type: 'daterange',
            format: 'yyyy-MM-dd',
            key: 'collectioTime',
            label: '领取时间',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '领取用户',
            placeholder: '请输入领取用户',
          },
          {
            comName: 'YkcInput',
            key: 'userOrgName',
            label: '归属客户',
            placeholder: '请输入归属客户',
          },
        ];
      }
      this.getData();
      this.queryForPageImportNumberApi();
    },
    methods: {
      /**
       * 点击查询
       * @param form
       */
      handleSearchConfirm(form) {
        this.currentPage = 1;
        const search = JSON.parse(JSON.stringify(form));
        if (search.collectioTime && search.collectioTime.length === 2) {
          [search.receiveTimeStart, search.receiveTimeEnd] = search.collectioTime;
        }

        // delete search.receiveTimeStart;
        // delete search.receiveTimeEnd;
        this.searchParams = search || {};
        this.getData();
      },
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
        console.log('列表按钮点击事件', button, event);
      },
      /**
       * 导出
       */
      exportBlob() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'cardCouponActivityReceiveRecordList',
            activityId: this.activityId || '',
            activityType: this.activityType || '',
            ...this.searchParams,
          },
        });
      },
      /**
       * 获取导入数量
       */
      queryForPageImportNumberApi() {
        couponActivity
          .queryForPageImportNumber({
            activityId: this.activityId || '',
          })
          .then(res => {
            this.count = res || 0;
          });
      },

      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.currentPage = current;
        this.getData();
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.currentPage = 1;
        this.pageSize = size;
        this.getData();
      },

      /**
       * @desc 判断是否超过350天（超期退款阈值）
       * */
      isOver350Days(receiveTime) {
        if (!receiveTime) return false;
        return dayjs().diff(dayjs(receiveTime), 'day') > 350;
      },
      /**
       * @desc 打开退款弹窗
       * */
      handleRefund(row) {
        const isOver350Days = this.isOver350Days(row.receiveTime);
        this.saleOrderNo = row.saleOrderNo || '';
        this.refundInfo = {
          saleOrderNo: row.saleOrderNo || '',
          userAccount: row.userAccount || '',
          refundableAmount: row.refundableAmount || '',
        };
        this.refundTitle = isOver350Days ? '申请超期退款' : '申请退款';
        this.refundForm.reason = '';
        this.showRefund = true;
      },

      /**
       * 弹窗关闭
       * */
      onCLose() {
        this.showRefund = false;
        this.saleOrderNo = '';
        this.refundInfo = { saleOrderNo: '', userAccount: '', refundableAmount: '' };
        this.refundForm.reason = '';
      },

      /**
       * 弹窗提交退款
       */
      onRefund() {
        this.$refs.refundForm.validate(valid => {
          if (!valid) return;
          const params = {
            saleOrderNo: this.saleOrderNo,
            reason: this.refundForm.reason,
          };
          couponActivity
            .couponReceiveRecordRefund(params)
            .then(() => {
              this.$message.success('退款成功');
              this.showRefund = false;
              this.saleOrderNo = '';
              this.refundInfo = { saleOrderNo: '', userAccount: '', refundableAmount: '' };
              this.refundForm.reason = '';
              this.getData();
            })
            .catch(err => {
              console.log(err);
            });
        });
      },

      /**
       * @desc 获取数据
       * */
      getData() {
        const reqData = {
          ...(this.searchParams || {}),
          current: this.currentPage,
          size: this.pageSize,
        };
        reqData.activityId = this.activityId || '';
        couponActivity.couponReceiveRecord(reqData).then(res => {
          this.tableData = res.records || [];
          this.total = res.total;
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .ykc-table-header-subtitle {
    font-size: 12px;
    margin-left: 28px;
  }
</style>
